module.exports = __webpack_public_path__ + "static/media/Fruitta.69a12ffe.svg";